import React from "react";
import styled from 'styled-components';
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";

const Footer = () => {
	const { width } = useWindowDimensions();
	return (
		<div >
		<Box style={{flexDirection: "column", paddingLeft: width * 0.1, paddingRight: width * 0.1}}>
			<Row style={width <= 768 ? { display: "block" } : {justifyContent: "space-between"} }>
				<p style={{fontSize: 12, color: colors.white, paddingTop: 20}}>
					Copyright © 2023 GearApp Inc. - GEARCHAIN: GearChain.io | GEAR NBS: GetGear.io | GEAR CLOUD: GearCS.com
				</p>
				<Row style={{marginTop: width <= 768 ? 0 : 35}}>
					<FooterBtn href="https://docs.gearchain.io/legal">Legal Notice</FooterBtn>
					<FooterBtn href="https://docs.gearchain.io/privacy" style={{paddingLeft: 50}}>Privacy Policy</FooterBtn>
				</Row>
			</Row>
			<Container>
			<LeftContainer>
				{/* <Logo alt="Gear" src={require("../assets/images/logo.png")} /> */}
				<MainHeading>
				We build a Transparent Supply Chain: Permissionless blockchain, Zero-code app builder with built-in barcode scanning. 
				</MainHeading>
			</LeftContainer>
			
			</Container>
			<Disclaimer >
				DISCLAIMER: This website contains non-binding preliminary information for promotional purposes for interested people with experience in dealing with cryptographic tokens and it does not constitute a prospectus, or any other document approved by or filed with any regulatory authority in Switzerland or abroad. This website is neither an offer nor a solicitation of an offer to purchase cryptographic tokens, such as the GEAR token, or any securities or other products. GEARCHAIN does not assure any future appreciation, certain future performance or profit potential in connection with GEAR tokens. GEARCHAIN reserves the right to exclude certain people from purchasing GEAR tokens based on any reasons (e.g., people from restricted countries, such as the U.S., or politically exposed persons). The information on this website does not constitute investment advice or an investment recommendation. While every care has been taken in preparing this website, errors and omissions are reserved. The statements made are based on estimates, economic data, own judgments and are forward-looking statements at the time of preparation of the website and may be subject to change. Therefore, this information is provided on the basis that neither GEARCHAIN nor partners or employees of GEARCHAIN are liable in any way for any errors or inaccuracies within this presentation.GEARCHAIN  assumes no liability for any loss or damage caused by the information contained herein or any possible error or inaccuracy. Decisive for the purchase and sale of the presented GEAR token is NOT this website, but exclusively the corresponding purchase agreement, SAFT agreement or the general terms and conditions to be accepted by buyers, where also the corresponding risks for a purchase of cryptographic tokens, such as the GEAR token, are described in detail. This website may not be reproduced, distributed to others or published, in whole or in part. People who come into possession of any documents presented on this website must inform themselves, do their own research about and comply with all applicable laws and regulations.
			</Disclaimer>
		</Box>
		</div>
	);
};

const Box = styled.div`
  padding: 40px 0px 40px 0px;
  bottom: 0;
  border-top: 1px solid dimgrey;
  border-bottom: 1px solid dimgrey;

  @media (max-width: 768px) {
	padding-top: 0px;
  }
`;
const Container = styled.div`
    display: flex;
	justify-content: space-between;
`

const Row = styled.div`
	display: flex;
`;

const MainHeading = styled.p`
    font-size: 14px;
    margin-bottom: 0px;
	color: #fff;

	/* @media (max-width: 768px) {
		text-align: center;
  } */
`

const LeftContainer = styled.div`
	width:450px;
	margin:0px;
	padding:0px;
`

const FooterBtn = styled.a`
	text-decoration: none;
	font-size: 12px;
	color: ${colors.white};

`

const Disclaimer = styled.p`
	font-size: 9px; 
	color: ${colors.grey};

	@media (max-width: 768px) {
		/* text-align: justify; */
  		/* text-justify: inter-word; */
	}
`
export default Footer;